<template >
  <div>
    <div v-if="loading" class="over container">
      <div class="row" style="height: 45vh">
        <div class="col-12"></div>
      </div>
      <div class="row">
        <div class="spinner-border text-primary center" role="status">
          <span class="sr-only"></span>
        </div>
      </div>
    </div>
    <div v-else>
      <div class="over container d-flex">
        <div class="myModal p-2 container row">
          <div
            class="row align-items-center justify-content-center align-self-center"
            style="height: 40%"
          >
            <div
              id="titleMainPage"
              class="row text-center justify-content-center center"
              style="color: #03ce39"
            >
              {{ title }}
            </div>
            <div id="stampGame" class="text-center">
              {{ lang }}{{ translation.stamp }}
            </div>
          </div>

          <div class="row align-items-center" style="height: 15%">
            <div class="col-12">
              <div class="py-3">
                <input
                  name="userName"
                  label="Pseudo"
                  id="userName"
                  v-model="userName"
                  required
                  placeholder="השם שלך"
                  class="center fullWidth text-center"
                  style="color: black; border: solid 2px rgb(84, 163, 49)"
                />
              </div>
            </div>
          </div>

          <div class="row align-items-center" style="height: 20%">
            <div class="col-12">
              <div
                class="p-2 h5 text-center rtl blur mb-4"
                style="max-width: 360px; color: white; border: 2px white solid"
              >
                <div class="rtl font-weight-bold">
                  {{ translation.beware }}
                </div>
                <div class="mt-2 blur">
                  {{ translation.startPoint }}
                </div>
              </div>
              <!-- <div
                class="p-2 h6 text-center"
                style="max-width: 360px; color: white; margin: 0 auto"
              >
                <div class="font-weight-bold">{{ translation.beware }}</div>
                {{ translation.startPoint }}
              </div> -->
              <button
                class="clickableButton btn font-weight-bold rtl"
                @click="checkIfName()"
              >
                {{ translation.letsGoButton }}
              </button>
            </div>
          </div>
        </div>
      </div>

      <div v-if="confirmName === true" class="over center">
        <div class="p-3 myModal2 container d-flex">
          <div class="row">
            <div
              class="px-2 mt-3 col-12 text-center rtl"
              style="font-family: 'noot', cursive; font-size: 33px"
            >
              יופי {{ userName }}!
            </div>
            <div class="px-2 mt-3 col-12 text-center">
              {{ translation.beforeStarting }}
            </div>
            <div
              class="colorBtn btn font-weight-bold position-relative col-5 ml-2 rtl"
              style="padding-top: 8px"
              @click="onSignin"
            >
              {{ translation.ok }}
            </div>
            <div
              class="position-relative text-center col-5"
              style="margin-top: 37px"
              @click="startGame"
            >
              {{ translation.skip }}
            </div>
          </div>
        </div>
      </div>

      <div v-if="showAlertNoName === true" class="over center">
        <div
          class="p-3 myModal2"
          style="background-color: rgb(84, 163, 49); color: white"
          @click="showAlertNoName = false"
        >
          <div class="mt-3 text-center">
            <div
              class="mt-3 rtl"
              style="font-family: 'noot', cursive; font-size: 40px"
            >
              אופס...
            </div>
            <div class="mt-3 text-center">{{ translation.noPassword }}</div>
          </div>
          <div class="font-weight-bold mt-5 mb-2 h4 text-center">
            {{ translation.gotIt }}
          </div>
        </div>
      </div>
    </div>
  </div>
</template>


<script>
export default {
  data() {
    return {
      translation: {
        stamp: "Jeu de piste",
        beware: "Attention!",
        startPoint: "Le jeu commence à la place de Meyrin Village",
        letsGoButton: "ON Y EST!",
        beforeStarting:
          "Avant de se lancer, vous pouvez rapidement recevoir quelques explications sur le fonctionnement de l'application.",
        ok: "Ca marche!",
        skip: "Non merci, passer",
        noPassword:
          "Il semblerait que vous avez oublié d'entrer un pseudo... C'est juste pour que vous puissiez voir à quelle place vous avez fini au classement.",
        gotIt: "Ok, j'ai compris",
      },
      confirmName: false,
      navigationName: "hanukaRamatDavid23",
      showAlertNoName: false,
      groupColorEnglish: "",
      userName: "",
      title: "חנוכה",
      userKey: "",
      language: "Français",
    };
  },
  mounted() {
    if (localStorage.getItem("navigationName")) {
      if (localStorage.getItem("navigationName") != this.navigationName) {
        localStorage.clear();
      }
    }
    if (localStorage.getItem("questionNumber")) {
      this.userName = localStorage.getItem("myNameOuchui");
      this.groupColorEnglish = localStorage.getItem("groupColorEnglish");
      // this.$store.dispatch("fetchSentence", {
      //   navigationName: this.navigationName
      // });
      this.userKey = localStorage.getItem("userKey");
      this.$store.dispatch("createNewUser", {
        userName: this.userName,
        navigationName: this.navigationName,
        groupColorEnglish: this.groupColorEnglish,
        pointNumber: localStorage.getItem("pointNumberOuchui"),
      });
      this.$store.dispatch("fetchGameData", {
        navigationName: this.navigationName,
        userName: this.userName,
        groupColorEnglish: this.groupColorEnglish,
      });
      let pushStartGame = setInterval(() => {
        if (this.loading == true) {
          console.log("loading");
        } else {
          // this.$router.push("/startGame");
          this.$router.push("/testing");

          clearInterval(pushStartGame);
        }
      }, 200);
      // setTimeout(() => {
      //   this.$router.push("/startGame");
      // }, 3000);
    }
  },
  computed: {
    lang() {
      return this.translate(this.$store.getters.lang);
    },
    error() {
      return this.$store.getters.error;
    },
    loading() {
      return this.$store.getters.loading;
    },
  },

  methods: {
    switchLangToFrench() {
      this.$store.dispatch("switchLangToFrench");
    },
    switchLangToEnglish() {
      this.$store.dispatch("switchLangToEnglish");
    },
    translate(lang) {
      switch (lang) {
        case "fr":
          this.translation = {
            stamp: "Jeu de piste",
            beware: "Attention!",
            startPoint: "Le jeu commence à la place de Meyrin Village",
            letsGoButton: "ON Y EST!",
            beforeStarting:
              "Avant de se lancer, vous pouvez rapidement recevoir quelques explications sur le fonctionnement de l'application.",
            ok: "Ca marche!",
            skip: "Non merci, passer",
            noPassword:
              "Il semblerait que vous avez oublié d'entrer un pseudo... C'est juste pour que vous puissiez voir à quelle place vous avez fini au classement.",
            gotIt: "Ok, j'ai compris",
          };
          console.log("french");
          break;
        case "en":
          this.translation = {
            stamp: "Jeu de piste",
            beware: "Attention!",
            startPoint: "The game begins at the Place of Meyrin Village",
            letsGoButton: "I'M HERE!",
            beforeStarting:
              "Before getting started, you can learn how the app works.",
            ok: "Sure!",
            skip: "No thanks, skip.",
            noPassword:
              "It looks like you forgot to enter a nickname... It's just so you can see where you ended up in the leaderboard.",
            gotIt: "Ok, got it",
          };
          console.log("english");

          // code block
          break;
        case "he":
          this.translation = {
            stamp: "רמת דוד",
            beware: "שימו לב!",
            startPoint: "המשחק מתחיל בחדר אוכל!",
            letsGoButton: "להתחיל",
            beforeStarting: "לפני שמתחילים, תראו איך זה עובד",
            ok: "בטח!",
            skip: "לא תודה",
            noPassword: "נראה ששכת להכניס את שמך",
            gotIt: "טוב בסדר",
          };
          console.log("english");

          // code block
          break;
        default:
        // code block
      }
    },
    startGame() {
      // this.$router.push("/startGame");
      this.$router.push("/testing");
    },
    checkIfName() {
      if (this.userName === "") {
        this.showAlertNoName = true;
      } else {
        localStorage.setItem("myNameOuchui", this.userName);
        localStorage.setItem("navigationName", this.navigationName);
        localStorage.setItem("groupColorEnglish", this.groupColorEnglish);
        this.confirmName = true;
        this.$store.dispatch("createNewUser", {
          userName: this.userName,
          navigationName: this.navigationName,
          groupColorEnglish: this.groupColorEnglish,
        });
        this.$store.dispatch("fetchGameData", {
          navigationName: this.navigationName,
          userName: this.userName,
          groupColorEnglish: this.groupColorEnglish,
        });
      }
    },
    onSignin() {
      this.$router.push("/welcomePage");
    },
    onDismissed() {
      this.$store.dispatch("clearError");
    },
  },
};
</script>

<style scoped>
.blur {
  backdrop-filter: blur(10px);
}
.clickableButton {
  background-color: rgb(84, 163, 49);
  width: 189px;
  height: 62px;
  border: 5px solid white;
  border-radius: 82px;
  font-size: 20px;
  display: block;
  margin: 0px auto;
  color: white;
}
.fullWidth {
  width: 95%;
  display: block;
  margin: 0px auto;
  border-radius: 36px;
  height: 56px;
  color: white;
}
#stampGame {
  color: #07f107;
  font-weight: 700;
  border: 0.25rem solid #07f107;
  display: inline-block;
  padding: 0.25rem 1rem;
  text-transform: uppercase;
  border-radius: 1rem;
  font-family: "Courier";
  -webkit-mask-image: url(https://s3-us-west-2.amazonaws.com/s.cdpn.io/8399/grunge.png);
  -webkit-mask-size: 944px 604px;
  mix-blend-mode: hard-light;
  position: absolute;
  top: 25%;
  -webkit-transform: rotate(20deg);
  transform: rotate(-10deg);
  z-index: 3;
  font-size: 23px;
  width: 225px;
  -webkit-animation-name: stamp;
  animation-name: stamp;
  -webkit-animation-duration: 2.2s;
  animation-duration: 2.2s;
  margin-left: 81px;
}
.myModal {
  display: block;
  margin: 0px auto;
  background: none;
}
#titleMainPage {
  font-family: VarelaRound;
  position: relative;
  font-size: 70px;
  color: #03ce39;
  background: 50% 100% / 50% 50% no-repeat
    radial-gradient(
      ellipse at bottom,
      rgb(111, 235, 28),
      transparent,
      transparent
    );
  -webkit-background-clip: text;
  background-clip: text;
  color: transparent;
  animation: reveal 1000ms ease-in-out forwards 200ms,
    glow 2500ms linear infinite 2000ms;
}

.main {
  display: flex;
  justify-content: center;
  align-items: flex-start;
  top: 52px;
  position: relative;
}
.moveTitle {
  animation-duration: 3s;
  animation-name: slidein;
}

.title {
  font-family: "Righteous", cursive;
  font-size: 70px;
  color: #cf1110;
  text-shadow: -1px 0 black, 0 1px black, 1px 0 black, 0 -1px black;
}
.ltr {
  direction: ltr;
  text-align: left;
}
.myModal2 {
  width: 320px;
  border-radius: 10px;
  display: block;
  margin: 0px auto;
  margin-top: calc(50vh - 170px);
  background-color: rgb(84, 163, 49);
  color: white;
  border: solid 2px white;
  height: auto;
}
.over {
  display: flex;
  align-items: center;
  justify-content: center;
  position: fixed;
  /* position: relative; */

  top: 0px;
  font-size: 18px;
  width: 100vw;
  max-width: 590px;
  height: 100vh;
  background: url("../../../static/img/hebrewWarior2.jpg") no-repeat center center;
  background-size: cover;
  background-color: rgba(0, 0, 0, 0.9);
}
.colorBtn {
  border-radius: 36px;
  color: rgb(84, 163, 49);
  margin: 0px auto;
  margin-top: 30px;
  background-color: white;
  padding-top: 14px;
}
.center {
  display: block;
  margin: 0px auto;
}
@keyframes reveal {
  80% {
    letter-spacing: 8px;
  }
  100% {
    background-size: 300% 300%;
  }
}
@keyframes glow {
  40% {
    text-shadow: 0 0 8px rgb(31, 250, 2);
  }
}
@keyframes stamp {
  0% {
    opacity: 0;
  }
  70% {
    opacity: 0;
  }
  85% {
    opacity: 0;
  }
  93% {
    opacity: 0;
  }
  94% {
    opacity: 0.5;
    transform-origin: 50% 50%;
    transform: scale(4);
    transition: all 0.1s cubic-bezier(0.6, 0.04, 0.98, 0.335);
  }
  100% {
    opacity: 1;
    transform: rotate(-20deg) scale(1);
  }
}
@keyframes animate {
  0% {
    opacity: 0;
    background-position: -500%;
    background-size: 80%;
  }
  20% {
    opacity: 1;
    background-position: 400%;
    background-size: 80%;
  }
  40% {
    background-position: -200%;
    background-size: 80%;
  }
  60% {
    background-position: 0%;
    background-size: 80%;
  }
  80% {
    background-position: 0%;
    background-size: 100%;
  }
  100% {
    background-position: 0%;
  }
}
@keyframes appear {
  0% {
    opacity: 0;
  }

  30%,
  70% {
    opacity: 0;
  }
  90% {
    opacity: 1;
  }
  93% {
    opacity: 0.5;
  }
  95% {
    opacity: 1;
    transform: scale(1.05);
  }
  98% {
    opacity: 0.5;
  }
  100% {
    opacity: 1;
  }
}

@keyframes slidein {
  0% {
    margin-left: 120vw;
  }
  72% {
    margin-left: 120vw;
  }

  98% {
    margin-left: 3%;
  }

  to {
    margin-left: 0%;
  }
}
@font-face {
  font-family: noot;
  src: url(../../../static/fonts/Noot/noot-aj.woff);
}
@font-face {
  font-family: VarelaRound;
  src: url(../../../static/fonts/VarelaRound-Regular.ttf);
}
</style>



